import React from 'react';
import Home from './pages/Home';
import './styles/global.scss'
const App:React.FC = () => {
  return (
    <Home />
  )
}

export default App